import { render, staticRenderFns } from "./SimpleEditor.vue?vue&type=template&id=23304e6f&"
import script from "./SimpleEditor.vue?vue&type=script&lang=js&"
export * from "./SimpleEditor.vue?vue&type=script&lang=js&"
import style0 from "./SimpleEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23304e6f')) {
      api.createRecord('23304e6f', component.options)
    } else {
      api.reload('23304e6f', component.options)
    }
    module.hot.accept("./SimpleEditor.vue?vue&type=template&id=23304e6f&", function () {
      api.rerender('23304e6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleEditor.vue"
export default component.exports